<template>
  <div class="table-responsive">
    <table class="table table-striped table-bordered">
      <thead class="table-dark">
      <tr>
        <th scope="col">{{ $t("athletes.table.img") }}</th>
        <th scope="col">{{ $t("athletes.table.name") }}</th>
        <th scope="col">{{ $t("athletes.table.status") }}</th>
        <th v-if="isDisable" scope="col">{{ $t("athletes.table.actions") }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="athlete in athletes" :key="athlete.id" @click.prevent="$emit('viewAthlete', athlete.user_id)">
        <td><img :src="athlete.user.img_path" alt="athlete.name" class="athlete-img" /></td>
        <td>{{ athlete.user.name }} {{ athlete.user.surname }}</td>
        <td>
          <i class="fa-solid fa-check-circle" :class="{'approved': athlete.status_id === 4, 'pending': athlete.status_id !== 4}"></i>
          {{ athlete.status.name }}
        </td>
        <td v-if="isDisable" class="action-buttons" @click.stop>
          <button class="action-btn delete"
                  @click="modalDelete(athlete.id)"
                  v-if="athlete.status_id === 1 && isOwnerOrganizer(user, competition) && !competition.started_at">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <button class="action-btn confirm"
                  @click="modalConfirm(athlete.id)"
                  v-if="athlete.status_id === 2 && isOwnerAthlete(user, athlete) && !competition.started_at">
            <i class="fa-solid fa-thumbs-up"></i>
          </button>

          <button class="action-btn reject"
                  @click="modalReject(athlete.id)"
              v-if="athlete.status_id !== 1 && (isOwnerAthlete(user, athlete) || isOwnerOrganizer(user, competition)) && !competition.started_at">
            <i class="fa-solid fa-user-slash"></i>
          </button>

          <button class="action-btn mail"
                  v-if="athlete.status_id === 1 && isOwnerOrganizer(user, competition) && !competition.started_at"
                  @click="modalSendEmail(athlete.id)"
                  :title="$t('athletes.send_mails_athtletes')">
            <i class="fa-solid fa-mail-bulk"></i>
          </button>

            <button class="action-btn payment"
              v-if="competitionHasFee && !athlete.fees_paid && athlete.status_id === 4 && isOwnerOrganizer(user,competition) && !competition.started_at"
              @click="modalPayment(athlete.id)">
            <i class="fa-solid fa-money-check-alt"></i>
          </button>

          <button class="action-btn approve"
                  @click="modalApprove(athlete.id)"
                  v-if="athlete.status_id === 3 && isOwnerOrganizer(user, competition) && !competition.started_at">
            <i class="fa-solid fa-check"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { isOwnerAthlete, isOwnerOrganizer } from '@/helpers/roleUtils';
import {mapState} from "vuex";

export default {
  name: "AthleteTable",
  props: {
    athletes: {
      type: Array,
      required: true,
      default: () => [],
    },
    competition: {
      type: Object,
      required: true,
    }
  },
  computed:{
    ...mapState('user', ['user']),
    isDisable(){
      return this.athletes.some(athlete => athlete.status_id !== 5);
    },
    competitionHasFee() {
      const raw = Number(this.competition?.competitions_info?.fees);
      return Number.isFinite(raw) && raw > 0;
    },
  },
  methods: {
    isOwnerAthlete,
    isOwnerOrganizer,
    modalDelete(id) {
      this.$emit('update-show-modal', 'deleteAthlete',id,this.$t('athletes.modal.delete_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalReject(id) {
      this.$emit('update-show-modal', 'rejectAthlete',id,this.$t('athletes.modal.decline_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalConfirm(id) {
      this.$emit('update-show-modal', 'confirmAthlete',id,this.$t('athletes.modal.confirm_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalPayment(id) {
      this.$emit('update-show-modal', 'confirmPayment',id,this.$t('athletes.modal.payment_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalApprove(id) {
      this.$emit('update-show-modal', 'approveAthlete',id,this.$t('athletes.modal.approve_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalSendEmail(id) {
      this.$emit('update-show-modal', 'sendEmailAthlete', id, this.$t('athletes.modal.send_invitation_confirmation'));
    }
  }
};
</script>

<style scoped>
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.table td, .table th {
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}
.table td{
  cursor: pointer;
}
.athlete-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.truncate-text {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 6px;
  transition: opacity 0.2s ease;
}

.action-btn.delete { color: #dc3545; }
.action-btn.confirm { color: #28a745; }
.action-btn.reject { color: #dc3545; }
.action-btn.mail { color: #c08b2f; }
.action-btn.payment { color: #ffc107; }
.action-btn.approve { color: #007bff; }

.action-btn:hover {
  opacity: 0.75;
}
@media (max-width: 768px) {
  .table-responsive {
    overflow-x: auto;
  }
  .action-buttons {
    flex-wrap: nowrap;
  }
}
</style>
